import React from 'react';
import { BodyText, LoadingImage, PageCover } from 'ui-toolkit';
import { CenterMessage } from './MessageView.styled';
import { Show } from '../shared/Show';

export const CreatingDisplay: React.FC<{ isFetching: boolean }> = ({ isFetching }) => {
  return (
    <Show when={isFetching}>
      <PageCover>
        <div>
          <CenterMessage>
            <LoadingImage />
            <BodyText>Sit tight, we're creating your order!</BodyText>
          </CenterMessage>
        </div>
      </PageCover>
    </Show>
  );
};
